var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogoText = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 35,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            @font-face{font-family:Monorale;font-weight:400;font-style:normal;src:url(/fonts/Monorale-Regular.woff) format(&apos;woff&apos;);font-display:fallback}@font-face{font-family:Monorale;font-weight:500;font-style:normal;src:url(/fonts/Monorale-Medium.woff) format(&apos;woff&apos;);font-display:fallback}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#93A5B2",
    fillRule: "evenodd",
    fontFamily: "Monorale"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 1.333
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16
  }, "WEB GATE")), /*#__PURE__*/React.createElement("text", {
    fontSize: 10,
    letterSpacing: 0.833
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 31
  }, "SCORER Edge")))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-text.a6c0ecf0.svg";
export { ForwardRef as ReactComponent };